import React, { useState, useEffect } from "react";
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from '@mui/material'; 

import Plot from 'react-plotly.js';

export const DQResult = ({ results }) =>{

  console.log("Results",results)

    const [totalRecords, setTotalRecords] = useState(0);
    const [completedRecords, setCompletedRecords] = useState(0);
    const [qualityScore, setQualityScore] = useState(0);
    const [weightage, setWeightage] = useState(null);
    const [chartData, setChartData] = useState(null);
    console.log("chart dataf", chartData
      
    )

    useEffect(()=>{
        if (results) {
            const total = results.rules?.length || 0;
            const completed = results.rules?.filter(rule => rule.dq_result !== "pass")?.length || 0;
            const score = results.latest_dimension_scores?.score || 0;
            const dimensionWeightage = results.latest_dimension_scores || {};
            const chart = results?.score_trend_plot_config;
            console.log("chart data",chart)
            const updatedWeightage = { ...dimensionWeightage }; 
            delete updatedWeightage.score; 
            setTotalRecords(total);
            setCompletedRecords(completed);
            setQualityScore(score);
            setWeightage(updatedWeightage);
            setChartData(chart);
        }
    }, [results])

    const getQualityScoreColor = (score) => {
        if (score > 85) return '#4CAF50';
        if (score >= 55) return '#FF9800';
        if (score < 55) return '#F44336';
        return '#000';
    };

    const SimpleStatCard = ({ title, value, color = '#1E88E5' }) => (
  <Box
    sx={{
      backgroundColor: '#fff',
      borderRadius: '16px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
      padding: 3,
      width: '200px',
      height: '120px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      border: '1px solid #d3d3d3',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      '&:hover': {
        boxShadow: '0 12px 30px rgba(0, 0, 0, 0.2) !important',
        transform: 'translateY(-6px) !important',
        border: '1px solid #bb1ccc !important',
        backgroundColor: '#f8f9ff'
      }
    }}
  >
        <Box>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 600, color, fontSize: '1.1rem' }}
          >
            {title}
          </Typography>
          <Box
            sx={{
              height: '3px',
              width: '40px',
              backgroundColor: color,
              borderRadius: '2px',
              mt: 0.5,
            }}
          />
        </Box>
    
        <Typography
          variant="h4"
          sx={{color: getQualityScoreColor(qualityScore), fontWeight: 700,  fontSize: '2rem'}}
        >
          {value}
        </Typography>
      </Box>
    );

    return (
        <div>
          {/* Disclaimer Section */}
          <Box
            sx={{
              backgroundColor: '#fff3cd',
              border: '1px solid #ffeaa7',
              borderRadius: '12px',
              padding: '16px 20px',
              marginBottom: '24px',
              display: 'flex',
              alignItems: 'flex-start',
              gap: '12px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
            }}
          >
            <Box
              sx={{
                color: '#856404',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '24px',
                height: '24px',
                borderRadius: '50%',
                backgroundColor: '#fff3cd',
                border: '2px solid #856404'
              }}
            >
              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: 700,
                  lineHeight: 1
                }}
              >
                ⚠
              </Typography>
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: 600,
                  color: '#856404',
                  marginBottom: '4px',
                  lineHeight: 1.4
                }}
              >
                Disclaimer
              </Typography>
              <Typography
                sx={{
                  fontSize: '13px',
                  color: '#856404',
                  lineHeight: 1.5,
                  opacity: 0.9
                }}
              >
                If there are no other rules apart from row count and schema check, results will not be available. Please add more rules to see complete results.
              </Typography>
            </Box>
          </Box>

          <div className="flex w-full">
            <div className="w-1/2">
            <Box sx={{ display: 'flex', gap: 4, mb: 2 }}>

            <SimpleStatCard title="DQ Score" value={qualityScore || 0} color="#bb1ccc" />
            <SimpleStatCard title="Rules Processed" value={totalRecords || 0} color="#bb1ccc" />
            <SimpleStatCard title="Rules Failed" value={completedRecords || 0} color="#bb1ccc" />
          
          </Box>
          </div>
          </div>

          <div className="flex w-full">
            <div className="w-1/2">
          <Box 
            sx={{ 
              backgroundColor: '#fff',
              borderRadius: '16px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
              padding: 3,
              border: '1px solid #d3d3d3',
              marginBottom: 2
            }}
          >
            <Typography 
              variant="h6" 
              sx={{
                color: '#bb1ccc',
                fontWeight: 700,
                fontSize: '1.1rem',
                marginBottom: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}
            >
              <Box
                sx={{
                  width: '4px',
                  height: '20px',
                  backgroundColor: '#bb1ccc',
                  borderRadius: '2px'
                }}
              />
              Dimension Level Score
            </Typography>
            <Box sx={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
              gap: 3,
              maxWidth: '100%'
            }}>
              {weightage && Object.entries(weightage)
                .filter(([key]) => key.endsWith('_weightage')) // Only process weightage entries
                .map(([key, value]) => {
                  // Extract score and weightage from the API response structure
                  const dimensionName = key.replace('_weightage', '');
                  const score = results?.latest_dimension_scores?.[dimensionName] || 0;
                  const weightageValue = value;
                  const contribution = score > 0 && weightageValue > 0 ? (score * weightageValue / 100).toFixed(2) : 0;
                  
                  return (
                    <Box 
                      key={key} 
                      sx={{
                        backgroundColor: weightageValue > 0 ? '#f0f9ff' : '#e5e2e2',
                        borderRadius: '12px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                        padding: 3,
                        border: '1px solid',
                        borderColor: weightageValue > 0 ? '#e0f2fe' : '#e5e2e2',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
                          transform: 'translateY(-2px)'
                        }
                      }}
                    >
                      <Typography 
                        variant="h6" 
                        sx={{
                          fontWeight: 700,
                          fontSize: '1rem',
                          color: '#1f2937',
                          marginBottom: 2,
                          textTransform: 'uppercase',
                          textAlign: 'center'
                        }}
                      >
                        {dimensionName.charAt(0).toUpperCase() + dimensionName.slice(1)}
                      </Typography>
                      
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {/* Score */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Typography 
                            variant="body2" 
                            sx={{
                              fontWeight: 600,
                              fontSize: '0.875rem',
                              color: '#6b7280'
                            }}
                          >
                            Score
                          </Typography>
                          <Typography 
                            sx={{
                              fontWeight: 700,
                              fontSize: '1.1rem',
                              color: score > 0 ? '#059669' : '#dc2626'
                            }}
                          >
                            {score}
                          </Typography>
                        </Box>
                        
                        {/* Weightage */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Typography 
                            variant="body2" 
                            sx={{
                              fontWeight: 600,
                              fontSize: '0.875rem',
                              color: '#6b7280'
                            }}
                          >
                            Weightage
                          </Typography>
                          <Typography 
                            sx={{
                              fontWeight: 700,
                              fontSize: '1.1rem',
                              color: '#374151'
                            }}
                          >
                            {weightageValue}%
                          </Typography>
                        </Box>
                        
                        {/* Contribution */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Typography 
                            variant="body2" 
                            sx={{
                              fontWeight: 600,
                              fontSize: '0.875rem',
                              color: '#6b7280'
                            }}
                          >
                            Contribution
                          </Typography>
                          <Typography 
                            sx={{
                              fontWeight: 700,
                              fontSize: '1.1rem',
                              color: score > 0 ? '#059669' : '#dc2626'
                            }}
                          >
                            {contribution}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
            </Box>
          </Box>
          </div>
          <div className="w-1/2 pl-4">
          <Box className="shadow-xl bg-white p-4 rounded" sx={{border: "2px solid #f5f5f5", padding: "10px", width: "100%", height: "fit-content"}} >
              <Typography variant="body2" color="text.secondary" sx={{fontWeight: "bold"}}>
                  DQ Score Trend
                </Typography>
              <Plot data={chartData?.data || []}
                layout={{
                          ...(chartData?.layout || {}),
                          margin: { t: 60, b: 80, ...(chartData?.layout?.margin || {}) }
                        }}
              />
          </Box>
          </div>
          </div>

          <TableContainer 
            component={Paper} 
            sx={{ 
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', 
              border: '1px solid #e0e0e0', 
              borderRadius: '12px',
              marginTop: "30px",
              maxHeight: '500px',
              overflow: 'auto'
            }}
          >
            <Table sx={{ minWidth: 650 }} stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ 
                    color: "white", 
                    fontWeight: 600, 
                    fontSize: '14px',
                    padding: '16px 20px',
                    borderBottom: '2px solid #bb1ccc',
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: '#bb1ccc !important'
                  }}>
                    Column Name
                  </TableCell>
                  <TableCell sx={{ 
                    color: "white", 
                    fontWeight: 600, 
                    fontSize: '14px',
                    padding: '16px 20px',
                    borderBottom: '2px solid #bb1ccc',
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: '#bb1ccc !important'
                  }}>
                    Rule Description
                  </TableCell>
                  <TableCell sx={{ 
                    color: "white", 
                    fontWeight: 600, 
                    fontSize: '14px',
                    padding: '16px 20px',
                    borderBottom: '2px solid #bb1ccc',
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: '#bb1ccc !important'
                  }}>
                    Dimension
                  </TableCell>
                  <TableCell sx={{ 
                    color: "white", 
                    fontWeight: 600, 
                    fontSize: '14px',
                    padding: '16px 20px',
                    borderBottom: '2px solid #000080',
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: '#bb1ccc!important'
                  }}>
                    Keywords
                  </TableCell>
                  <TableCell sx={{ 
                    color: "white", 
                    fontWeight: 600, 
                    fontSize: '14px',
                    padding: '16px 20px',
                    borderBottom: '2px solid #bb1ccc',
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: '#bb1ccc !important'
                  }}>
                    Status
                  </TableCell>
                  <TableCell sx={{ 
                    color: "white", 
                    fontWeight: 600, 
                    fontSize: '14px',
                    padding: '16px 20px',
                    borderBottom: '2px solid #bb1ccc',
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: '#bb1ccc !important'
                  }}>
                    Score
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {results?.rules?.length > 0 ? (
                  results.rules.map((rule, index) => (
                    <TableRow 
                      key={rule.rule_name}
                      sx={{ 
                        backgroundColor: index % 2 === 0 ? '#fafafa' : '#ffffff',
                        '&:hover': {
                          backgroundColor: '#f0f8ff',
                          transition: 'background-color 0.2s ease'
                        }
                      }}
                    >
                      <TableCell sx={{ 
                        padding: '16px 20px',
                        fontWeight: 600,
                        fontSize: '14px',
                        color: '#2c3e50'
                      }}>
                        {rule.check_type === "Asset Level Check" ? "Asset Level Rule" : rule.column_name}
                      </TableCell>
                      <TableCell sx={{ 
                        padding: '16px 20px',
                        fontSize: '14px',
                        color: '#555',
                        maxWidth: '300px',
                        wordWrap: 'break-word'
                      }}>
                        {rule.rule_description}
                      </TableCell>
                      <TableCell sx={{ 
                        padding: '16px 20px',
                        fontSize: '14px',
                        color: '#555',
                        textTransform: 'capitalize'
                      }}>
                        {rule.dimension_name.charAt(0).toUpperCase() + rule.dimension_name.slice(1)}
                      </TableCell>
                      <TableCell sx={{ 
                        padding: '16px 20px',
                        fontSize: '14px',
                        color: '#555',
                        textTransform: 'capitalize'
                      }}>
                        {rule.keywords}
                      </TableCell>
                      <TableCell sx={{ 
                        padding: '16px 20px',
                        fontSize: '14px'
                      }}>
                        <Box
                          sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            px: 2,
                            py: 0.5,
                            borderRadius: '20px',
                            fontSize: '12px',
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            backgroundColor: rule.dq_result === "pass" ? '#e8f5e8' : '#ffeaea',
                            color: rule.dq_result === "pass" ? '#2e7d32' : '#d32f2f'
                          }}
                        >
                          {rule.dq_result === "pass" ? "Pass" : rule.dq_result === "fail" ? "Fail" : rule.dq_result === "FAILURE" ? "Not Run" : "N/A"}
                        </Box>
                      </TableCell>
                      <TableCell sx={{ 
                        padding: '16px 20px',
                        fontSize: '14px',
                        fontWeight: 600,
                        color: getQualityScoreColor(rule.quality_score)
                      }}>
                        {rule.quality_score}%
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell 
                      colSpan={5} 
                      align="center"
                      sx={{ 
                        padding: '40px 20px',
                        fontSize: '16px',
                        color: '#666',
                        fontStyle: 'italic'
                      }}
                    >
                      No rules found for the selected dataset.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
    )}